import { useEffect, useRef } from "react";

/**
 * Clears UI/config-related user data when the selected terminal changes.
 *
 * This moves the clearing logic out of `TerminalContext` so other components
 * (like Configure tab) can reuse it without introducing new behavior.
 */
export const useClearUserDataOnTerminalChange = (
  terminalId: number | null,
  setReadyConfig: (r: any) => void,
  setError: (e: string | null) => void,
  setFileList: (f: any[]) => void,
  setReadyConfigHistory: (h: any[]) => void,
  setCurrentReadyHistoryIndex: (i: number) => void,
  setCurrentConfigSrc: (src: string | null) => void
) => {
  // Track previous terminal id to detect changes
  const prevRef = useRef<number | null>(terminalId);

  useEffect(() => {
    // Only run cleanup if the terminal ID actually changed
    if (prevRef.current !== terminalId) {
      setReadyConfig(null);
      setError(null);
      setFileList([]);
      setReadyConfigHistory([]);
      setCurrentReadyHistoryIndex(-1);
      setCurrentConfigSrc(null);
    }
    prevRef.current = terminalId;
  }, [
    terminalId,
    setReadyConfig,
    setError,
    setFileList,
    setReadyConfigHistory,
    setCurrentReadyHistoryIndex,
    setCurrentConfigSrc,
  ]);
};
